module.exports = __webpack_public_path__ + "img/DIGI75282.c1e1c51f.jpg";